import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

export const CLIENT_VISIT_SNAPSHOT_TYPES = [
  { id: 'prenatal', label: 'Prenatal' },
  { id: 'postpartum', label: 'Postpartum' },
  { id: 'newborn', label: 'Newborn' },
  { id: 'lactation', label: 'Lactation Visit' },
  { id: 'well-woman', label: 'Well-Woman' },
  { id: 'call-log', label: 'Call Logs' },
];

const settingsEndpoint = `${config.api.url}/organization/client-visit-snapshot-settings`;
const backfillEndpoint = `${config.api.url}/organization/client-visit-snapshots/backfill`;

const normalizeSettings = (value = {}) => ({
  enabledVisitTypes: value.enabledVisitTypes ?? value.EnabledVisitTypes ?? [],
  updatedAt: value.updatedAt ?? value.UpdatedAt ?? null,
});

const normalizeSnapshot = (value = {}) => ({
  referenceId: value.referenceId ?? value.ReferenceId,
  visitType: value.visitType ?? value.VisitType,
  visitDate: value.visitDate ?? value.VisitDate,
  visitTime: value.visitTime ?? value.VisitTime,
  summary: value.summary ?? value.Summary ?? '',
  notes: value.notes ?? value.Notes ?? null,
  providerName: value.providerName ?? value.ProviderName ?? null,
  lockedAt: value.lockedAt ?? value.LockedAt ?? null,
  publishedAt: value.publishedAt ?? value.PublishedAt ?? null,
  updatedAt: value.updatedAt ?? value.UpdatedAt ?? null,
});

const request = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

const clientVisitSnapshotsApi = {
  getSettings: async (clientReferenceId = null) => {
    const suffix = clientReferenceId
      ? `?clientReferenceId=${encodeURIComponent(clientReferenceId)}`
      : '';
    return normalizeSettings(await request(`${settingsEndpoint}${suffix}`));
  },

  updateSettings: async (enabledVisitTypes) => normalizeSettings(await request(settingsEndpoint, {
    method: 'PUT',
    body: JSON.stringify({ enabledVisitTypes }),
  })),

  previewBackfill: async (payload) => request(`${backfillEndpoint}/preview`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),

  backfill: async (payload) => request(backfillEndpoint, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),

  getClientSnapshots: async (clientReferenceId) => {
    const value = await request(
      `${config.api.url}/clients/${encodeURIComponent(clientReferenceId)}/visit-snapshots`,
    );
    const snapshots = Array.isArray(value)
      ? value
      : value?.items ?? value?.Items ?? value?.$values ?? [];
    return snapshots.map(normalizeSnapshot);
  },
};

export default clientVisitSnapshotsApi;
